export default __webpack_public_path__ + "static/media/Skirmisher's War Maul.65b70f38.jpg";